/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningClearanceRule } from './InternalApiScreeningClearanceRule';
import {
    InternalApiScreeningClearanceRuleFromJSON,
    InternalApiScreeningClearanceRuleFromJSONTyped,
    InternalApiScreeningClearanceRuleToJSON,
    InternalApiScreeningClearanceRuleToJSONTyped,
} from './InternalApiScreeningClearanceRule';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRulesPage
 */
export interface InternalApiScreeningClearanceRulesPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRulesPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiScreeningClearanceRule>}
     * @memberof InternalApiScreeningClearanceRulesPage
     */
    content: Array<InternalApiScreeningClearanceRule>;
}

/**
 * Check if a given object implements the InternalApiScreeningClearanceRulesPage interface.
 */
export function instanceOfInternalApiScreeningClearanceRulesPage(value: object): value is InternalApiScreeningClearanceRulesPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRulesPageFromJSON(json: any): InternalApiScreeningClearanceRulesPage {
    return InternalApiScreeningClearanceRulesPageFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRulesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiScreeningClearanceRuleFromJSON)),
    };
}

export function InternalApiScreeningClearanceRulesPageToJSON(json: any): InternalApiScreeningClearanceRulesPage {
    return InternalApiScreeningClearanceRulesPageToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRulesPageToJSONTyped(value?: InternalApiScreeningClearanceRulesPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiScreeningClearanceRuleToJSON)),
    };
}

